/* ============================================================
   MCH — SIGNAL · cart engine
   /cart/add.js + /cart/change.js, drawer re-render via
   Section Rendering API (?sections=signal-cart-drawer)
   ============================================================ */
(() => {
  'use strict';

  const drawer = () => document.querySelector('.js-cart-drawer');

  function counts(n) {
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = n;
      el.classList.remove('is-bump');
      void el.offsetWidth;
      el.classList.add('is-bump');
    });
    if (window.MCH) window.MCH.cartCount = n;
  }

  function applyDrawerHtml(html) {
    if (!html) return false;
    const tmp = document.createElement('div');
    tmp.innerHTML = html;
    const fresh = tmp.querySelector('.js-cart-drawer');
    const cur = drawer();
    if (!fresh || !cur) return false;
    const wasOpen = cur.classList.contains('is-open');
    cur.replaceWith(fresh);
    if (wasOpen) {
      fresh.classList.add('is-open');
      fresh.setAttribute('aria-hidden', 'false');
    }
    bindDrawer();
    counts(parseInt(fresh.dataset.count || '0', 10));
    return true;
  }

  // Fallback only: a separate GET can be served stale by Shopify's page cache,
  // so mutations request the drawer HTML inside their own response instead.
  async function refreshDrawer() {
    const res = await fetch(`${location.pathname}?sections=signal-cart-drawer&_=${Date.now()}`, { cache: 'no-store', headers: { Accept: 'application/json' } });
    if (!res.ok) return;
    const data = await res.json();
    applyDrawerHtml(data['signal-cart-drawer']);
  }

  function open() {
    const d = drawer();
    if (!d) return;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    document.body.classList.add('no-scroll');
    const c = d.querySelector('[data-overlay-close]');
    setTimeout(() => c && c.focus(), 160);
  }
  function close() {
    const d = drawer();
    if (!d) return;
    d.classList.remove('is-open');
    d.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('no-scroll');
  }

  async function add(items, opts = {}) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: Array.isArray(items) ? items : [items],
        sections: 'signal-cart-drawer',
        sections_url: location.pathname,
      }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      throw new Error(data.description || 'Nije uspelo dodavanje. Probaj ponovo.');
    }
    if (!applyDrawerHtml(data.sections && data.sections['signal-cart-drawer'])) {
      await refreshDrawer();
    }
    if (!opts.silent) open();
    return data;
  }

  async function changeLine(line, quantity) {
    const d = drawer();
    const row = d && d.querySelector(`[data-line="${line}"]`);
    row && row.classList.add('is-busy');
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity, sections: 'signal-cart-drawer', sections_url: location.pathname }),
    });
    const data = await res.json().catch(() => ({}));
    if (!res.ok) {
      row && row.classList.remove('is-busy');
      window.MCHtoast && window.MCHtoast(`<span class="err">✕</span> ${data.description || 'Greška u korpi.'}`);
      return;
    }
    if (!applyDrawerHtml(data.sections && data.sections['signal-cart-drawer'])) {
      await refreshDrawer();
    }
  }

  function bindDrawer() {
    const d = drawer();
    if (!d) return;
    d.addEventListener('click', (e) => {
      if (e.target.closest('[data-overlay-close]') || e.target.classList.contains('cd__scrim')) { close(); return; }

      const plus = e.target.closest('[data-qty-plus]');
      const minus = e.target.closest('[data-qty-minus]');
      const rm = e.target.closest('[data-line-remove]');
      if (plus || minus || rm) {
        e.preventDefault();
        const row = e.target.closest('[data-line]');
        if (!row) return;
        const line = parseInt(row.dataset.line, 10);
        const q = parseInt(row.dataset.qty, 10);
        if (rm) return changeLine(line, 0);
        return changeLine(line, plus ? q + 1 : Math.max(0, q - 1));
      }

      const up = e.target.closest('[data-upsell-add]');
      if (up) {
        e.preventDefault();
        up.classList.add('is-busy');
        add({ id: parseInt(up.dataset.upsellAdd, 10), quantity: 1 }, { silent: true })
          .then(() => window.MCHtoast && window.MCHtoast('<span class="ok">✓</span> Dodato u korpu'))
          .catch((err) => window.MCHtoast && window.MCHtoast(`<span class="err">✕</span> ${err.message}`));
      }
    });
  }

  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-cart-open]');
    if (opener) { e.preventDefault(); open(); }
  });
  addEventListener('keydown', (e) => {
    const d = drawer();
    if (e.key === 'Escape' && d && d.classList.contains('is-open')) close();
  });
  bindDrawer();

  /* quick add buttons (product cards) */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();
    const id = parseInt(btn.dataset.quickAdd, 10);
    if (!id) return;
    const label = btn.textContent;
    btn.classList.add('is-busy');
    btn.textContent = 'Dodajem…';
    add({ id, quantity: 1 })
      .catch((err) => window.MCHtoast && window.MCHtoast(`<span class="err">✕</span> ${err.message}`))
      .finally(() => { btn.classList.remove('is-busy'); btn.textContent = label; });
  });

  /* cart PAGE steppers: same /cart/change.js flow, then reload the page */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('.cartpg [data-qty-plus], .cartpg [data-qty-minus]');
    if (!btn) return;
    e.preventDefault();
    const row = btn.closest('[data-line]');
    if (!row || row.classList.contains('is-busy')) return;
    row.classList.add('is-busy');
    const line = parseInt(row.dataset.line, 10);
    const q = parseInt(row.dataset.qty, 10);
    const next = btn.hasAttribute('data-qty-plus') ? q + 1 : Math.max(0, q - 1);
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line, quantity: next }),
    })
      .then(async (res) => {
        if (!res.ok) {
          const err = await res.json().catch(() => ({}));
          throw new Error(err.description || 'Greška u korpi.');
        }
        location.reload();
      })
      .catch((err) => {
        row.classList.remove('is-busy');
        window.MCHtoast && window.MCHtoast(`<span class="err">✕</span> ${err.message}`);
      });
  });

  window.MCHcart = { add, open, close, refreshDrawer };
})();
